// /api/workspace/jobs returns every job in the authorized company/book scope.
// Search/filter the complete response before limiting rendered rows. Do not use
// this model with a paged response without first following its cursor.
export const ARTWORK_SERVICES = {bezel_drop:'Bezel Drop',individual:'Individual Design',platinum:'Platinum 3D'}
export const ARTWORK_STATUSES = {saved:'Saved inventory; open original details',progress:'Artwork in progress',review:'Saved files; optional review',ready:'Saved artwork available',internal:'Saved artwork; review recorded'}
export const ARTWORK_QUEUE = [['all','All next actions'],['unassigned','Needs assignment'],['overdue','Overdue next action'],['missing','No next action']]
export const ARTWORK_DIRECTORY_KEYS = ['artQ','artOwner','artService','artStatus','artQueue','artSort','artPage','artFlow','artDeleted']
export const ARTWORK_JOB_TABS = ['brief','create','engine','files','quality','history']
const text=value=>String(value??'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase()
export function hasSavedOriginal(job){
 return (job.assets || []).some(a=>a.role==='artwork_engine_output' && !a.synthetic && !a.held && !a.holdReason && !a.heldReason && a.transportKind!=='synthetic_test' && (!a.queueId || a.outputAspectValidation) && /^[a-f0-9]{64}$/.test(a.sha256 || '') && Number.isSafeInteger(a.bytes) && a.bytes>0
  && [job.artworkEngine,...(job.artworkEngine?.history || [])].some(e=>e && !e.provenance?.synthetic && e.revision===a.engineRevision && e.specFingerprint===a.specFingerprint))
}
export function artworkStatus(job,engineOnly=false){
  if(job.readinessScope==='saved_inventory_requires_detail_refresh')return 'saved'
  if(engineOnly || job.artworkEngine){
    if(job.engineReadiness?.customerHandoffReady)return 'ready'
    if(job.engineReadiness?.ready)return 'internal'
    if(job.artworkEngine?.outputAssetId)return 'review'
    return 'progress'
  }
  return job.readiness?.ready?'ready':job.readiness?.filesReady?'review':'progress'
}
export function artworkSearchText(job){
  return text([job.id,job.title,job.ownerName,job.ownerId,job.companyId,job.championshipId,job.contactId,
    ARTWORK_SERVICES[job.tier],job.spec?.schoolName,job.spec?.year,job.spec?.titleTop,job.spec?.titleBottom,
    job.artworkEngine?.spec?.sport,job.artworkEngine?.spec?.year,job.artworkEngine?.spec?.mode,
    job.nextAction?.text,...(job.assets||[]).flatMap(a=>[a.name,a.originalName])].filter(Boolean).join(' '))
}
export function artworkDirectoryFilters(params){return {q:params.get('artQ')||'',owner:params.get('artOwner')||'',service:params.get('artService')||'',status:params.get('artStatus')||'',queue:params.get('artQueue')||'all',sort:params.get('artSort')||'updated',engineOnly:params.get('artFlow')==='engine',deleted:params.get('artDeleted')==='1'}}
export function filterArtworkJobs(index,filters,now=Date.now()){
  const terms=text(filters.q).trim().split(/\s+/).filter(Boolean)
  return index.filter(({job,search})=>{
    if(Boolean(job.deletedAt)!==Boolean(filters.deleted))return false
    if(filters.engineOnly&&!job.artworkEngine)return false
    if(filters.owner&&String(job.ownerId||'unassigned')!==filters.owner)return false
    if(filters.service&&job.tier!==filters.service)return false
    if(filters.status&&artworkStatus(job,filters.engineOnly)!==filters.status)return false
    if(filters.queue==='unassigned'&&job.ownerId)return false
    if(filters.queue==='overdue'&&(!Number.isFinite(Date.parse(job.nextAction?.dueAt))||job.nextAction.completedAt||Date.parse(job.nextAction.dueAt)>=now))return false
    if(filters.queue==='missing'&&job.nextAction?.text&&!job.nextAction.completedAt)return false
    return terms.every(term=>search.includes(term))
  }).map(({job})=>job).sort((a,b)=>{
    if(filters.sort==='title')return String(a.title||'').localeCompare(String(b.title||''))
    const date=j=>filters.sort==='due'?(j.nextAction?.completedAt?Infinity:Date.parse(j.nextAction?.dueAt)||Infinity):-(Date.parse(j.updatedAt)||0)
    return date(a)-date(b)||String(a.id).localeCompare(String(b.id))
  })
}
export function artworkJobHref(params,id,tab='files',engineStep=null){
  const next=new URLSearchParams(params)
  next.set('job',id);next.set('jobTab',ARTWORK_JOB_TABS.includes(tab)?tab:'files')
  if(tab==='engine'){next.set('tool','engine');if(engineStep)next.set('engineStep',engineStep)}else next.delete('tool')
  return `/artwork-studio?${next}`
}
export function artworkResultsHref(params){const next=new URLSearchParams(params);next.delete('job');next.delete('jobTab');next.delete('tool');return `/artwork-studio${next.size?'?'+next:''}`}
export function safeCommandReturn(value){
  if(!value||!value.startsWith('/command-center')||value.startsWith('//'))return null
  try {const u=new URL(value,'https://local.invalid');return u.origin==='https://local.invalid'&&u.pathname==='/command-center'?u.pathname+u.search:null}catch{return null}
}

export function safeArtworkReturn(value){
  if(!value||!value.startsWith('/artwork-studio')||value.startsWith('//'))return null
  try {const u=new URL(value,'https://local.invalid');return u.origin==='https://local.invalid'&&u.pathname==='/artwork-studio'?u.pathname+u.search:null}catch{return null}
}
export function artworkJourneyHref(params,id,tab='files'){
  const next=new URLSearchParams({tab:'accounts',job:id,artworkReturn:artworkJobHref(params,id,tab)})
  return `/workspace?${next}`
}
